
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class DesignSelectGrid extends _Ext.GridBase<OMS.DesignRow, any> {
        protected getColumnsKey() { return 'OMS.Design'; }
        protected getDialogType() { return <any>OMS.DesignDialog; }
        protected getIdProperty() { return OMS.DesignRow.idProperty; }
        protected getLocalTextPrefix() { return OMS.DesignRow.localTextPrefix; }
        protected getService() { return OMS.DesignService.baseUrl; }
        //protected get_ExtGridOptions() { return Q.deepClone(q.DefaultMainGridOptions) }
        //protected getInsertPermission() { return DesignRow.insertPermission; }
        //protected getUpdatePermission() { return DesignRow.updatePermission; }
        //protected getDeletePermission() { return DesignRow.deletePermission; }
        //protected useViewMode() { return true; } 
     
        constructor(container: JQuery, options: any ) {
            super(container,options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
       
            return this;
        }

        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize(); // *** If you want to make it autoresize when grid is loaded, use: new Slick.AutoColumnSize(true);
            grid.registerPlugin(this.autoSize);



            return grid;
        }

        protected createToolbarExtensions(): void {
            super.createToolbarExtensions()

        }
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            return opt;
        }
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        } 

        get selectedItems(): OMS.DesignRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return true; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;
           
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    } 
}